var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import loginDI from "@frameworks/salesjourney/components/Login/di/index";
import { getDateInFormat } from "@domains/utils/reportDates";
import React, { useEffect, useRef, useState } from "react";
import { Row, Spinner, Accordion } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { assignedByMeGroupKey, assignedToGroupKey, jointTabKey, singleDigitToDoubleDigit, } from "./constant";
import Loader from "@frameworks/shared-library/components/Loader";
import GenericToast from "@frameworks/shared-library/components/GenericToast";
import clientDi from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import leadId from "./di/serviceLocator";
import { ETypeOfContact, } from "@domains/salesFeatures/Common/entities/iFilterTypeOfContactEntity";
import { addCommasWithoutDecimal } from "@domains/utils/numberMethods";
import loginDi from "@frameworks/salesjourney/components/Login/di/index";
import { config } from "@frameworks/salesjourney/config/domain";
import { Link } from "react-router-dom";
import { EActiveProductFeedbackTab, } from "./LeadTableNPagination";
import di from "./di/serviceLocator";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
import { leadStatusConfig } from "@frameworks/salesjourney/utils/commonLeadStatusConfig";
import { IEditLeadAccessPayloadEnum } from "@domains/salesFeatures/Lead/entities/IEditLeadAccess";
import GenericTooltip from "../../../../shared-library/components/GenericTooltip";
import ClientTier from "@frameworks/salesjourney/components/Generic/ClientTier";
import { EProductFeedback } from "@domains/salesFeatures/Common/entities/ISalesJourneyMastersData";
import Edelicon from "@frameworks/shared-library/components/Generic/Edelicon";
import { EAnswerType } from "../../Lead/constant";
import { urlMapper } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFund";
var ViewLeadNew = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
    var _2 = __read(React.useState(""), 2), comment = _2[0], setComment = _2[1];
    var _3 = __read(useState(props.leadAssign), 2), selectedLead = _3[0], setSelectedLead = _3[1];
    var myRef = useRef(null);
    var executeScroll = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setActiveItem(function (prev) { return "Comments"; });
            setTimeout(function () {
                if (myRef)
                    myRef.current.scrollIntoView({ behaviour: "smooth" });
            }, 300);
            return [2 /*return*/];
        });
    }); };
    var _4 = __read(useState(""), 2), activeItem = _4[0], setActiveItem = _4[1];
    var navigate = useNavigate();
    var userId = useSelector(function (state) { var _a, _b; return (_b = (_a = state.Profile.ProfileDetails.reducersData.data) === null || _a === void 0 ? void 0 : _a.profileDetails) === null || _b === void 0 ? void 0 : _b.userId; });
    var _5 = __read(React.useState({
        internalComments: [],
        totalCommentsCount: 0,
    }), 2), internalComments = _5[0], setInternalComments = _5[1];
    var _6 = __read(useState(), 2), oldViewLeadData = _6[0], setOldViewLeadData = _6[1];
    var _7 = __read(useState([]), 2), newViewLeadDataFormat = _7[0], setNewViewLeadDataFormat = _7[1];
    var _8 = __read(React.useState(false), 2), loader = _8[0], setLoader = _8[1];
    var _9 = __read(React.useState(false), 2), viewLoader = _9[0], setViewLoader = _9[1];
    var _10 = __read(React.useState(false), 2), redirectionError = _10[0], setRedirectionError = _10[1];
    var _11 = __read(React.useState(""), 2), leadRedirectinURL = _11[0], setLeadRedirectionURL = _11[1];
    var _12 = __read(useState(null), 2), ChildLeadData = _12[0], setChildLeadData = _12[1];
    var _13 = __read(React.useState(false), 2), isShowRedirectionPopup = _13[0], setIsShowRedirectionPopup = _13[1];
    var getInternalComments = function (leadId) {
        setLoader(true);
        var requestPayload = {
            leadId: leadId ? leadId : oldViewLeadData.data.leadId,
            page: "1",
            pageSize: "1000",
        };
        di.leads
            .getInternalComments(requestPayload)
            .then(function (data) {
            setInternalComments(data);
            setLoader(false);
        })
            .catch(function (error) {
            setLoader(false);
        });
    };
    var getProductFeedback = function (leadData) {
        var _a, _b;
        var productFeedbackList = [];
        var likedData = {
            count: 0,
            feedback: [],
        };
        var dislikedData = {
            count: 0,
            feedback: [],
        };
        var otherData = {
            count: 0,
            feedback: [],
        };
        if (((_a = leadData === null || leadData === void 0 ? void 0 : leadData.feedbacklist) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            (_b = leadData === null || leadData === void 0 ? void 0 : leadData.feedbacklist) === null || _b === void 0 ? void 0 : _b.map(function (record) {
                var _a;
                switch ((_a = record === null || record === void 0 ? void 0 : record.feedbacktype) === null || _a === void 0 ? void 0 : _a.toUpperCase()) {
                    case EProductFeedback.LIKE:
                        likedData.count += 1;
                        (record === null || record === void 0 ? void 0 : record.productfeedback) &&
                            likedData.feedback.push(record.productfeedback);
                        break;
                    case EProductFeedback.DISLIKE:
                        dislikedData.count += 1;
                        (record === null || record === void 0 ? void 0 : record.productfeedback) &&
                            dislikedData.feedback.push(record.productfeedback);
                        break;
                    case EProductFeedback.OTHER:
                        otherData.count += 1;
                        (record === null || record === void 0 ? void 0 : record.productfeedback) &&
                            otherData.feedback.push(leadData.productFeedback);
                        break;
                    default:
                        if (record.feedbackid === leadStatusConfig.productFeedbackOtherId &&
                            !!leadData.productFeedback) {
                            otherData.count += 1;
                            otherData.feedback.push(leadData.productFeedback);
                        }
                        break;
                }
                // productFeedbackList.push(record.productfeedback);
            });
        }
        // if (leadData?.productFeedback) {
        // productFeedbackList.push(leadData.productFeedback);
        // }
        var feedbackModalData = {
            likedData: likedData,
            dislikedData: dislikedData,
            otherData: otherData,
        };
        props.setProductFeedbackModalData(feedbackModalData);
        return (React.createElement("div", { className: "d-flex align-items-center gap-3 product-feedback-info-container" },
            React.createElement("div", { className: "d-flex flex-column gap-2 align-items-center ".concat(!!likedData.count ? "hand_cursor" : ""), onClick: function () {
                    !!likedData.count &&
                        (props === null || props === void 0 ? void 0 : props.handleOpenModal(true, EActiveProductFeedbackTab.LIKED_FEEDBACK));
                } },
                React.createElement("i", { className: "edel-icon-like" }),
                React.createElement("div", { className: "DMSanN_14_400 ".concat(!!likedData.count
                        ? "text-decoration-underline"
                        : "txt_primaryGrey") }, singleDigitToDoubleDigit(likedData.count))),
            React.createElement("div", { className: "d-flex flex-column gap-2 align-items-center ".concat(!!dislikedData.count ? "hand_cursor" : ""), onClick: function () {
                    !!dislikedData.count &&
                        (props === null || props === void 0 ? void 0 : props.handleOpenModal(true, EActiveProductFeedbackTab.DISLIKED_FEEDBACK));
                } },
                React.createElement("i", { className: "edel-icon-dislike1" }),
                React.createElement("div", { className: "DMSanN_14_400 ".concat(!!dislikedData.count
                        ? "text-decoration-underline"
                        : "txt_primaryGrey") }, singleDigitToDoubleDigit(dislikedData.count))),
            React.createElement("div", { className: "d-flex flex-column gap-2 align-items-center ".concat(!!otherData.count ? "hand_cursor" : ""), onClick: function () {
                    !!otherData.count &&
                        (props === null || props === void 0 ? void 0 : props.handleOpenModal(true, EActiveProductFeedbackTab.OTHER_FEEDBACK));
                } },
                React.createElement("i", { className: "edel-icon-round-circle txt_rich-electric-blue" }),
                React.createElement("div", { className: "DMSanN_14_400 ".concat(!!otherData.count
                        ? "text-decoration-underline"
                        : "txt_primaryGrey") }, singleDigitToDoubleDigit(otherData.count)))));
        // return productFeedbackList.join(",");
    };
    var getChildLeadData = function (leadId) {
        var payloads = {
            leadId: leadId,
        };
        di.leads
            .getChildLeadData(payloads)
            .then(function (result) {
            setChildLeadData(result.childData.data);
        })
            .catch(function (error) {
            console.log("childLead error", error);
        });
    };
    var getEditLeadURL = function (x) {
        var _a, _b, _c;
        var editUrl = config.applicationFolder +
            "dashboard/leadpage/" +
            window.btoa((_a = x === null || x === void 0 ? void 0 : x.data) === null || _a === void 0 ? void 0 : _a.leadId) +
            "/" +
            window.btoa(String((_b = x === null || x === void 0 ? void 0 : x.data) === null || _b === void 0 ? void 0 : _b.isClient)) +
            "/" +
            window.btoa(String((_c = x === null || x === void 0 ? void 0 : x.data) === null || _c === void 0 ? void 0 : _c.isParent));
        return editUrl;
    };
    var getClientSearchDataList = function (searchText) {
        if (!!searchText) {
            clientDi.clients
                .getClientSearchList({ searchText: searchText })
                .then(function (resp) {
                var _a;
                if (resp && (resp === null || resp === void 0 ? void 0 : resp.length) > 0) {
                    if ((_a = resp[0]) === null || _a === void 0 ? void 0 : _a.isPartner) {
                        var searchActionPayload = {
                            AcCode: resp[0].accountCode,
                            page: 1,
                            pageSize: 100,
                        };
                        clientDi.clients.clearSelectedClientData();
                        clientDi.partnerOverview.getPartnerSearchAction(searchActionPayload, resp[0]);
                    }
                    else {
                        clientDi.partnerOverview.clearALLStoreData();
                        clientDi.clients.setSelectedClientOnSearchClick(resp[0]);
                    }
                    navigate("/clientdetails/overview?link=".concat(resp[0].isPartner ? "profile" : "overview"));
                }
            });
        }
    };
    var convertLeadDataSectionWise = function (leadData, returnUrl, redirectionPopUp) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var newLeadDataFormat = [
            {
                title: "Task Descripton",
                details: [
                    {
                        subtitle: "",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.taskDescription) ? leadData === null || leadData === void 0 ? void 0 : leadData.taskDescription : "-",
                    },
                ],
            },
            {
                title: (leadData === null || leadData === void 0 ? void 0 : leadData.isClient) ? "Client Details" : "Partner Details",
                details: [
                    { subtitle: "Lead Id", value: leadData.leadId },
                    {
                        subtitle: "Lead Date",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.createdDate)
                            ? getDateInFormat(leadData === null || leadData === void 0 ? void 0 : leadData.createdDate, "DD MMM YYYY")
                            : "-",
                    },
                    {
                        subtitle: "Lead Name",
                        value: (React.createElement(React.Fragment, null, (leadData === null || leadData === void 0 ? void 0 : leadData.customertype) === "Lead" ||
                            (leadData === null || leadData === void 0 ? void 0 : leadData.customertype) === "Partner Lead" ? (React.createElement(React.Fragment, null, leadData === null || leadData === void 0 ? void 0 :
                            leadData.firstName,
                            !!(leadData === null || leadData === void 0 ? void 0 : leadData.middleName) ? " ".concat(leadData.middleName) : "",
                            !!(leadData === null || leadData === void 0 ? void 0 : leadData.lastName) ? " ".concat(leadData === null || leadData === void 0 ? void 0 : leadData.lastName) : "")) : (React.createElement(React.Fragment, null,
                            React.createElement("a", { href: props === null || props === void 0 ? void 0 : props.getClientSearchDataList(leadData === null || leadData === void 0 ? void 0 : leadData.uccCode, leadData === null || leadData === void 0 ? void 0 : leadData.isClient), className: "txt_black text-decoration-underline", onClick: function (e) {
                                    e.stopPropagation();
                                    // getClientSearchDataList(x?.uccCode);
                                } }, leadData === null || leadData === void 0 ? void 0 :
                                leadData.firstName,
                                " " +
                                    ((leadData === null || leadData === void 0 ? void 0 : leadData.middleName)
                                        ? leadData.middleName + " "
                                        : " "),
                                (leadData === null || leadData === void 0 ? void 0 : leadData.lastName) !== null ? leadData === null || leadData === void 0 ? void 0 : leadData.lastName : " "))))),
                    },
                    {
                        subtitle: (leadData === null || leadData === void 0 ? void 0 : leadData.isClient) ? "Client UCC" : "Partner UPC",
                        value: leadData.uccCode ? leadData.uccCode : "-",
                    },
                    { subtitle: "Email", value: leadData.email ? leadData === null || leadData === void 0 ? void 0 : leadData.email : "-" },
                    {
                        subtitle: "Mobile",
                        value: leadData.mobile
                            ? "".concat((leadData === null || leadData === void 0 ? void 0 : leadData.countryprefix) ? "+" + (leadData === null || leadData === void 0 ? void 0 : leadData.countryprefix) : "", " ").concat(leadData === null || leadData === void 0 ? void 0 : leadData.mobile)
                            : "-",
                    },
                    {
                        subtitle: "Potential ".concat((leadData === null || leadData === void 0 ? void 0 : leadData.isClient) ? "Client" : "Partner", " Tier"),
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.potentialtier) ? leadData === null || leadData === void 0 ? void 0 : leadData.potentialtier : "-",
                    },
                    {
                        subtitle: (leadData === null || leadData === void 0 ? void 0 : leadData.isClient) ? "Client Type" : "Partner Type",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.nrinonnriid) === leadStatusConfig.nri.id
                            ? "NRI (Non-Resident Indian)"
                            : (leadData === null || leadData === void 0 ? void 0 : leadData.nrinonnriid) === leadStatusConfig.nonNri.id
                                ? "Indian"
                                : "-",
                    },
                ],
            },
            {
                title: "Product Details",
                details: [
                    {
                        subtitle: "Meeting Type",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.bucketName) ? leadData === null || leadData === void 0 ? void 0 : leadData.bucketName : "-",
                    },
                    {
                        subtitle: "Source",
                        value: leadData.sourceName ? leadData.sourceName : "-",
                    },
                    {
                        subtitle: "Sub Source",
                        value: leadData.subSourceName ? leadData.subSourceName : "-",
                    },
                    {
                        subtitle: "Product",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.productName) ? leadData === null || leadData === void 0 ? void 0 : leadData.productName : "-",
                    },
                    {
                        subtitle: "Category",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.categoryName) ? leadData === null || leadData === void 0 ? void 0 : leadData.categoryName : "-",
                    },
                    {
                        subtitle: "Scheme",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.bucketId) == (leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.engagementBucketId)
                            ? (leadData === null || leadData === void 0 ? void 0 : leadData.subCategoryName)
                                ? leadData === null || leadData === void 0 ? void 0 : leadData.subCategoryName
                                : "-"
                            : (leadData === null || leadData === void 0 ? void 0 : leadData.displayName)
                                ? leadData === null || leadData === void 0 ? void 0 : leadData.displayName
                                : "-",
                    },
                    {
                        subtitle: "Pipeline",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.amount)
                            ? addCommasWithoutDecimal(leadData === null || leadData === void 0 ? void 0 : leadData.amount.replace(",", ""))
                            : "-",
                    },
                    {
                        subtitle: "Product Feedback",
                        value: 
                        // leadData?.feedbacklist?.length > 0
                        //   ? getProductFeedback(leadData)
                        //   : "-",
                        getProductFeedback(leadData),
                    },
                    {
                        subtitle: "Pending Pipeline",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.pendingpipelinevalue)
                            ? addCommasWithoutDecimal((_b = (_a = leadData === null || leadData === void 0 ? void 0 : leadData.pendingpipelinevalue) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.replace(",", ""))
                            : "-",
                    },
                ],
            },
            {
                title: "Meeting Details",
                details: [
                    {
                        subtitle: "Mode Of Engagement",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.typeOfContact)
                            ? ETypeOfContact[leadData === null || leadData === void 0 ? void 0 : leadData.typeOfContact]
                            : "-",
                    },
                    {
                        subtitle: "Did Meeting Happen",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.didMeetingHappend) ? "Yes" : "No",
                    },
                    {
                        subtitle: "Meeting Date & Time",
                        value: (React.createElement(React.Fragment, null,
                            React.createElement("span", { className: "px-0" },
                                (leadData === null || leadData === void 0 ? void 0 : leadData.callMeetingDate)
                                    ? getDateInFormat(leadData === null || leadData === void 0 ? void 0 : leadData.callMeetingDate, "DD MMM YYYY")
                                    : "",
                                " ",
                                (leadData === null || leadData === void 0 ? void 0 : leadData.callMeetingTime) && (leadData === null || leadData === void 0 ? void 0 : leadData.callMeetingDate)
                                    ? ""
                                    : "-",
                                (leadData === null || leadData === void 0 ? void 0 : leadData.callMeetingTime) ? leadData === null || leadData === void 0 ? void 0 : leadData.callMeetingTime : ""))),
                    },
                    {
                        subtitle: "Joint Meeting",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.isJointMeeting) ? "Yes" : "No",
                    },
                    {
                        subtitle: "Primary Owner",
                        value: ((_c = leadData === null || leadData === void 0 ? void 0 : leadData.primaryOwner) === null || _c === void 0 ? void 0 : _c.name)
                            ? (_d = leadData === null || leadData === void 0 ? void 0 : leadData.primaryOwner) === null || _d === void 0 ? void 0 : _d.name
                            : "-",
                    },
                    {
                        subtitle: "Participants",
                        value: ((_e = leadData === null || leadData === void 0 ? void 0 : leadData.employeeWithMettingName) === null || _e === void 0 ? void 0 : _e.length)
                            ? (_f = leadData === null || leadData === void 0 ? void 0 : leadData.employeeWithMettingName) === null || _f === void 0 ? void 0 : _f.join(", ")
                            : "-",
                    },
                    {
                        subtitle: "Ext Participants",
                        value: ((_g = leadData === null || leadData === void 0 ? void 0 : leadData.nonEmployeeWithMettingName) === null || _g === void 0 ? void 0 : _g.length)
                            ? (_h = leadData === null || leadData === void 0 ? void 0 : leadData.nonEmployeeWithMettingName) === null || _h === void 0 ? void 0 : _h.join(", ")
                            : "-",
                    },
                    {
                        subtitle: "Interaction Status",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.subStatus) ? leadData === null || leadData === void 0 ? void 0 : leadData.subStatus : "-",
                    },
                    {
                        subtitle: "Interaction Sub Status",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.interaction_sub_status)
                            ? leadData === null || leadData === void 0 ? void 0 : leadData.interaction_sub_status
                            : "-",
                    },
                ],
            },
            {
                title: "Follow Up Details",
                details: [
                    {
                        subtitle: "Interested Priority",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.interaction_priority)
                            ? leadData === null || leadData === void 0 ? void 0 : leadData.interaction_priority
                            : "-",
                    },
                    {
                        subtitle: "Response",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.response) ? leadData === null || leadData === void 0 ? void 0 : leadData.response : "-",
                    },
                    {
                        subtitle: "Follow Up Type",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.followupMode)
                            ? ETypeOfContact[leadData === null || leadData === void 0 ? void 0 : leadData.followupMode]
                            : "-",
                    },
                    {
                        subtitle: "Follow Up Date",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.followUpDate)
                            ? getDateInFormat(leadData === null || leadData === void 0 ? void 0 : leadData.followUpDate, "DD MMM YYYY")
                            : "-",
                    },
                    {
                        subtitle: "Follow Up Count",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.consecutiveFollowUp)
                            ? leadData === null || leadData === void 0 ? void 0 : leadData.consecutiveFollowUp
                            : "-",
                    },
                    {
                        subtitle: "Reactivation Count",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.reactivationCount)
                            ? leadData === null || leadData === void 0 ? void 0 : leadData.reactivationCount
                            : "-",
                    },
                    {
                        subtitle: "Reactivation Date",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.reactivationDate)
                            ? leadData === null || leadData === void 0 ? void 0 : leadData.reactivationDate
                            : "-",
                    },
                    {
                        subtitle: "Due Date",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.dueDate)
                            ? getDateInFormat(leadData === null || leadData === void 0 ? void 0 : leadData.dueDate, "DD MMM YYYY")
                            : "-",
                    },
                    {
                        subtitle: "Lead Status",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.statusName) ? leadData === null || leadData === void 0 ? void 0 : leadData.statusName : "-",
                    },
                    {
                        subtitle: "Closure Month",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.closuremonth) ? leadData === null || leadData === void 0 ? void 0 : leadData.closuremonth : "-",
                    },
                ],
            },
            {
                title: "Order Details",
                details: [
                    {
                        subtitle: "Order Id",
                        value: !loginDI.login.getIsRMPartnerFRM().isPartner &&
                            (leadData === null || leadData === void 0 ? void 0 : leadData.orderId) &&
                            (leadData === null || leadData === void 0 ? void 0 : leadData.isClient) ? (React.createElement(React.Fragment, null, (returnUrl !== "" && returnUrl !== undefined) ||
                            (leadRedirectinURL !== undefined &&
                                leadRedirectinURL !== "") ? (!!redirectionPopUp ? (React.createElement("div", { className: "DMSansNormal_12_400 txt_primaryGrey p-0 ".concat((leadData === null || leadData === void 0 ? void 0 : leadData.orderId)
                                ? "hand_cursor text-decoration-underline p-0"
                                : "p-0") }, (leadData === null || leadData === void 0 ? void 0 : leadData.orderId) ? leadData === null || leadData === void 0 ? void 0 : leadData.orderId : "-")) : (React.createElement("a", { onContextMenu: function (event) {
                                if ((leadData === null || leadData === void 0 ? void 0 : leadData.categoryName) === "Mutual Fund") {
                                    return event.preventDefault();
                                }
                            }, className: "DMSansNormal_12_400 txt_primaryGrey p-0 ".concat((leadData === null || leadData === void 0 ? void 0 : leadData.orderId)
                                ? "hand_cursor text-decoration-underline p-0"
                                : "p-0"), href: returnUrl ? returnUrl : leadRedirectinURL, target: "_blank" }, (leadData === null || leadData === void 0 ? void 0 : leadData.orderId) ? leadData === null || leadData === void 0 ? void 0 : leadData.orderId : "-"))) : (React.createElement("div", { className: "DMSansNormal_12_400 txt_primaryGrey p-0 ".concat(!loginDI.login.getIsRMPartnerFRM().isPartner && "p-0", " ").concat((leadData === null || leadData === void 0 ? void 0 : leadData.orderId) &&
                                ((leadRedirectinURL !== undefined &&
                                    leadRedirectinURL !== "") ||
                                    redirectionPopUp)
                                ? "hand_cursor text-decoration-underline p-0"
                                : "p-0") }, (leadData === null || leadData === void 0 ? void 0 : leadData.orderId) ? leadData === null || leadData === void 0 ? void 0 : leadData.orderId : "-")))) : (React.createElement("div", { className: "DMSansNormal_12_400 txt_primaryGrey p-0 ".concat(!loginDI.login.getIsRMPartnerFRM().isPartner &&
                                (leadData === null || leadData === void 0 ? void 0 : leadData.orderId)
                                ? "hand_cursor text-decoration-underline p-0"
                                : "p-0") }, "-")),
                    },
                    {
                        subtitle: "Order Status",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.onboardingResponse)
                            ? leadData === null || leadData === void 0 ? void 0 : leadData.onboardingResponse
                            : "-",
                    },
                    {
                        subtitle: "Order Value",
                        value: (leadData === null || leadData === void 0 ? void 0 : leadData.orderValue) ? leadData === null || leadData === void 0 ? void 0 : leadData.orderValue : "-",
                    },
                    {
                        subtitle: "Std Response",
                        value: props.leadAssign.standardResponse
                            ? props.leadAssign.standardResponse
                            : "-",
                    },
                ],
            },
        ];
        setNewViewLeadDataFormat(newLeadDataFormat);
    };
    var getViewLeadDetails = function (LeadId) {
        setViewLoader(true);
        var payloads = {
            LeadId: LeadId,
        };
        di.leads
            .getViewLeadData(payloads)
            .then(function (data) {
            var _a, _b, _c;
            if (!((_a = loginDI.login.getIsRMPartnerFRM()) === null || _a === void 0 ? void 0 : _a.isPartner) &&
                !!(data === null || data === void 0 ? void 0 : data.data) &&
                !!((_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.orderId) &&
                ((_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.orderId)) {
                var redirectionUrl_1 = "";
                leadRedirection(data === null || data === void 0 ? void 0 : data.data)
                    .then(function (resp) {
                    if (resp === null || resp === void 0 ? void 0 : resp.showPopUp) {
                        props === null || props === void 0 ? void 0 : props.setOrderIdPopUpInfo({
                            url: resp === null || resp === void 0 ? void 0 : resp.url,
                            msg: resp === null || resp === void 0 ? void 0 : resp.message,
                        });
                        redirectionUrl_1 = resp.url;
                        setIsShowRedirectionPopup(true);
                        setLeadRedirectionURL(resp === null || resp === void 0 ? void 0 : resp.url);
                        setOldViewLeadData(data);
                        convertLeadDataSectionWise(data.data, redirectionUrl_1, !!(resp === null || resp === void 0 ? void 0 : resp.showPopUp));
                        setViewLoader(false);
                    }
                    else if (resp.url !== "" &&
                        (resp === null || resp === void 0 ? void 0 : resp.url) !== null &&
                        (resp === null || resp === void 0 ? void 0 : resp.url) !== undefined) {
                        props === null || props === void 0 ? void 0 : props.setOrderIdPopUpInfo({
                            url: resp === null || resp === void 0 ? void 0 : resp.url,
                            msg: resp === null || resp === void 0 ? void 0 : resp.message,
                        });
                        redirectionUrl_1 = resp.url;
                        setIsShowRedirectionPopup(!!(resp === null || resp === void 0 ? void 0 : resp.showPopUp));
                        setLeadRedirectionURL(resp === null || resp === void 0 ? void 0 : resp.url);
                        setOldViewLeadData(data);
                        convertLeadDataSectionWise(data.data, redirectionUrl_1, !!(resp === null || resp === void 0 ? void 0 : resp.showPopUp));
                        setViewLoader(false);
                    }
                    else {
                        setIsShowRedirectionPopup(false);
                        setLeadRedirectionURL("");
                        setOldViewLeadData(data);
                        convertLeadDataSectionWise(data.data);
                        setViewLoader(false);
                        props === null || props === void 0 ? void 0 : props.setOrderIdPopUpInfo({
                            url: "",
                            msg: "",
                            isShow: false,
                        });
                    }
                })
                    .catch(function (error) {
                    setIsShowRedirectionPopup(false);
                    setLeadRedirectionURL("");
                    setOldViewLeadData(data);
                    convertLeadDataSectionWise(data.data);
                    setViewLoader(false);
                    props === null || props === void 0 ? void 0 : props.setOrderIdPopUpInfo({
                        url: "",
                        msg: "",
                        isShow: false,
                    });
                });
            }
            else {
                setOldViewLeadData(data);
                convertLeadDataSectionWise(data.data);
                setViewLoader(false);
            }
        })
            .catch(function (err) {
            setViewLoader(false);
        });
    };
    useEffect(function () {
        var _a, _b, _c;
        if (props === null || props === void 0 ? void 0 : props.leadAssign) {
            getViewLeadDetails((_a = props.leadAssign) === null || _a === void 0 ? void 0 : _a.leadId);
            getInternalComments((_b = props.leadAssign) === null || _b === void 0 ? void 0 : _b.leadId);
            getChildLeadData((_c = props.leadAssign) === null || _c === void 0 ? void 0 : _c.leadId);
        }
    }, [props === null || props === void 0 ? void 0 : props.leadAssign]);
    var updateInternalComment = function (comment) {
        var internalCommentReq = {
            leadId: selectedLead.leadId,
            notes: comment,
        };
        di.leads
            .updateInternalComments(internalCommentReq)
            .then(function (resp) {
            if (resp.response && resp.responseDescription) {
                setComment("");
                getInternalComments();
            }
        })
            .catch(function (error) { });
    };
    var leadRedirection = function (leadData) {
        var _a;
        var req = {
            leadId: leadData === null || leadData === void 0 ? void 0 : leadData.leadId,
            orderId: (_a = leadData === null || leadData === void 0 ? void 0 : leadData.orderId) === null || _a === void 0 ? void 0 : _a.toString(),
            leadSource: "SALESJOURNEY",
            email: leadData === null || leadData === void 0 ? void 0 : leadData.email,
            mobile: leadData === null || leadData === void 0 ? void 0 : leadData.mobile,
            product: leadData === null || leadData === void 0 ? void 0 : leadData.productId.toString(),
            category: leadData === null || leadData === void 0 ? void 0 : leadData.categoryId.toString(),
        };
        return leadId.leads.getLeadRedirection(req);
    };
    // useEffect(() => {
    //   if (oldViewLeadData?.data?.orderId.toString()) {
    //     leadRedirection(oldViewLeadData?.data?.orderId.toString());
    //   }
    // }, [oldViewLeadData?.data?.orderId]);
    var hanleonClickForOrderIdRedirection = function (property) {
        return function (e) {
            var _a, _b, _c, _d, _e;
            if ((property === null || property === void 0 ? void 0 : property.subtitle) === "Order Id" &&
                oldViewLeadData.data.categoryName === "Mutual Fund") {
                e.preventDefault();
                var url = new URL(leadRedirectinURL);
                var params = new URLSearchParams(url.search);
                var urlPath = url.pathname;
                var isRedirectionForOrderbook = urlPath.endsWith("orderbook");
                var isRedirectionForPlaceOrder = urlPath.endsWith("place-order");
                if (isRedirectionForPlaceOrder) {
                    params.set("ucc", (_a = params.get("ucc")) !== null && _a !== void 0 ? _a : "");
                    params.set("isin", (_b = params.get("isin")) !== null && _b !== void 0 ? _b : "");
                    params.set("categoryCode", "261");
                    var newUrl = "".concat(config.applicationFolder, "dashboard/place-order?").concat(params.toString());
                    window.open(newUrl, "_blank");
                }
                if (isRedirectionForOrderbook) {
                    params.set("orderId", (_c = params.get("orderId")) !== null && _c !== void 0 ? _c : "");
                    params.set("orderDate", (_e = (_d = params.get("orderdate")) === null || _d === void 0 ? void 0 : _d.split(" ")[0]) !== null && _e !== void 0 ? _e : "");
                    params.set("productCode", String(urlMapper[261]));
                    params.set("categoryCode", "261");
                    params.set("productType", "1");
                    var newUrl = "".concat(config.applicationFolder, "dashboard/orderbook?").concat(params.toString());
                    window.open(newUrl, "_blank");
                }
            }
        };
    };
    return (React.createElement(React.Fragment, null,
        !viewLoader ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "viewlead-summary-container" },
                React.createElement("div", { className: "" },
                    React.createElement("div", { className: "owner-and-assigner" },
                        React.createElement("div", { className: "section " },
                            React.createElement("span", { className: "DMSansNormal_12_400" }, "Current Lead Owner"),
                            React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1 d-flex align-items-center " },
                                React.createElement("div", { className: "marquee marquee--hover-pause" },
                                    React.createElement("ul", { className: "marquee__content p-0 m-0" },
                                        React.createElement("li", null, ((_a = oldViewLeadData === null || oldViewLeadData === void 0 ? void 0 : oldViewLeadData.data) === null || _a === void 0 ? void 0 : _a.dealerEmpName)
                                            ? (_b = oldViewLeadData === null || oldViewLeadData === void 0 ? void 0 : oldViewLeadData.data) === null || _b === void 0 ? void 0 : _b.dealerEmpName
                                            : "-")),
                                    React.createElement("ul", { "aria-hidden": "true", className: "marquee__content p-0 m-0" },
                                        React.createElement("li", null, ((_c = oldViewLeadData === null || oldViewLeadData === void 0 ? void 0 : oldViewLeadData.data) === null || _c === void 0 ? void 0 : _c.dealerEmpName)
                                            ? (_d = oldViewLeadData === null || oldViewLeadData === void 0 ? void 0 : oldViewLeadData.data) === null || _d === void 0 ? void 0 : _d.dealerEmpName
                                            : "-"))),
                                React.createElement("div", { className: "ms-1 sidebar-client-tier" }, ((_e = props === null || props === void 0 ? void 0 : props.leadAssign) === null || _e === void 0 ? void 0 : _e.clientTier) ? (React.createElement(GenericTooltip, { placement: "bottom", toolTipText: (_f = props === null || props === void 0 ? void 0 : props.leadAssign) === null || _f === void 0 ? void 0 : _f.clientTier, triggerType: "hover", toolTipClassName: "lead-table-tooltip", noButton: true, button: React.createElement(ClientTier, { clientTier: (_g = props === null || props === void 0 ? void 0 : props.leadAssign) === null || _g === void 0 ? void 0 : _g.clientTier, showOnlyIcon: true }) })) : ("")))),
                        props.leadTabFlag === assignedToGroupKey ? (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "section", onClick: function () { return props.assigntoMePopup(true); } },
                                React.createElement("i", { className: "edel-icon-assign me-2" }),
                                React.createElement("span", { className: "DMSansNormal_12_400" }, "Assign Lead to me")))) : (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "section" },
                                React.createElement("span", { className: "DMSansNormal_12_400" }, props.leadTabFlag === assignedByMeGroupKey
                                    ? "Assigned by me to "
                                    : "Assigned to me by "),
                                React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1" }, ((_h = oldViewLeadData === null || oldViewLeadData === void 0 ? void 0 : oldViewLeadData.data) === null || _h === void 0 ? void 0 : _h.assignedByEmpName) !== null &&
                                    ((_j = oldViewLeadData === null || oldViewLeadData === void 0 ? void 0 : oldViewLeadData.data) === null || _j === void 0 ? void 0 : _j.assignedByEmpName) !== undefined
                                    ? (_k = oldViewLeadData === null || oldViewLeadData === void 0 ? void 0 : oldViewLeadData.data) === null || _k === void 0 ? void 0 : _k.assignedByEmpName
                                    : "-"))))),
                    React.createElement("div", { className: "comment-assign-edit-lead" },
                        React.createElement("div", { className: "comments-btn-container d-flex flex-column align-items-center" },
                            React.createElement("i", { className: "edel-icon-chat-coloured" },
                                React.createElement("span", { className: "path1" }),
                                React.createElement("span", { className: "path2" }),
                                React.createElement("span", { className: "path3" }),
                                React.createElement("span", { className: "path4" })),
                            React.createElement(EdButton, { btnTyp: "black_one", value: "Comments (".concat((_m = (_l = internalComments === null || internalComments === void 0 ? void 0 : internalComments.internalComments) === null || _l === void 0 ? void 0 : _l.length) !== null && _m !== void 0 ? _m : 0, ")"), className: "text-decoration-underline comment-assign-btn", onClick: function () {
                                    setActiveItem("Comments");
                                    executeScroll();
                                } })),
                        React.createElement("div", { className: "assign-edit-lead-section d-flex align-items-center " },
                            React.createElement("div", { className: "icon-and-lable" }, !loginDi.login.getIsRMPartnerFRM().isPartner && (React.createElement(React.Fragment, null, (props === null || props === void 0 ? void 0 : props.reassignLeadChildLoader) ? (React.createElement(Spinner, { animation: "border", variant: "primary", size: "sm" })) : (React.createElement(React.Fragment, null,
                                React.createElement("i", { className: "edel-icon-reassign-lead" },
                                    React.createElement("span", { className: "path1" }),
                                    React.createElement("span", { className: "path2" }),
                                    React.createElement("span", { className: "path3" }),
                                    React.createElement("span", { className: "path4" })),
                                React.createElement(EdButton, { btnTyp: "black_one", type: "button", value: "Assign Lead", className: "text-decoration-underline DMSanN_14_400 txt_black comment-assign-btn", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var _a;
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    _a = props.leadTabFlag !== jointTabKey;
                                                    if (!_a) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, props.isAuthorizedToAssignLead(props.leadAssign.leadId, true)];
                                                case 1:
                                                    _a = (_b.sent());
                                                    _b.label = 2;
                                                case 2:
                                                    if (_a) {
                                                        props.setAssignLead(props.leadAssign);
                                                    }
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); } })))))),
                            React.createElement(Link, { to: props === null || props === void 0 ? void 0 : props.getEditURL(props.leadAssign), state: props === null || props === void 0 ? void 0 : props.getStateObject, className: "icon-and-lable" },
                                ((_p = (_o = props === null || props === void 0 ? void 0 : props.leadAssign) === null || _o === void 0 ? void 0 : _o.statusId) === null || _p === void 0 ? void 0 : _p.toString()) ===
                                    leadStatusConfig.expiredNotConvertedStatusIdForLead ? (React.createElement("i", { className: "edel-icon-double-refresh hand_cursor" })) : (React.createElement("i", { className: "edel-icon-edit-lead" },
                                    React.createElement("span", { className: "path1" }),
                                    React.createElement("span", { className: "path2" }),
                                    React.createElement("span", { className: "path3" }),
                                    React.createElement("span", { className: "path4" }),
                                    React.createElement("span", { className: "path5" }),
                                    React.createElement("span", { className: "path6" }),
                                    React.createElement("span", { className: "path7" }),
                                    React.createElement("span", { className: "path8" }),
                                    React.createElement("span", { className: "path9" }))),
                                React.createElement("span", { className: "txt_black text-decoration-underline DMSanN_14_400 hand_cursor" }, ((_r = (_q = props === null || props === void 0 ? void 0 : props.leadAssign) === null || _q === void 0 ? void 0 : _q.statusId) === null || _r === void 0 ? void 0 : _r.toString()) ===
                                    leadStatusConfig.expiredNotConvertedStatusIdForLead
                                    ? "Reactivate"
                                    : "Edit Lead")),
                            ((_s = props === null || props === void 0 ? void 0 : props.leadAssign) === null || _s === void 0 ? void 0 : _s.isParent) &&
                                (((_t = props === null || props === void 0 ? void 0 : props.leadAssign) === null || _t === void 0 ? void 0 : _t.parentLeadId) === null ||
                                    ((_u = props === null || props === void 0 ? void 0 : props.leadAssign) === null || _u === void 0 ? void 0 : _u.parentLeadId) === undefined ||
                                    ((_v = props === null || props === void 0 ? void 0 : props.leadAssign) === null || _v === void 0 ? void 0 : _v.parentLeadId) === "") && (React.createElement("div", { className: "icon-and-lable" },
                                React.createElement("i", { className: "edel-icon-split-coloured" },
                                    React.createElement("span", { className: "path1" }),
                                    React.createElement("span", { className: "path2" })),
                                React.createElement("a", { className: "txt_black text-decoration-underline DMSanN_14_400 hand_cursor", href: "#", target: "_blank", onClick: function (e) {
                                        var _a, _b, _c, _d;
                                        e.preventDefault();
                                        if (((_a = props === null || props === void 0 ? void 0 : props.leadAssign) === null || _a === void 0 ? void 0 : _a.isParent) &&
                                            (((_b = props === null || props === void 0 ? void 0 : props.leadAssign) === null || _b === void 0 ? void 0 : _b.parentLeadId) === null ||
                                                ((_c = props === null || props === void 0 ? void 0 : props.leadAssign) === null || _c === void 0 ? void 0 : _c.parentLeadId) === undefined ||
                                                ((_d = props === null || props === void 0 ? void 0 : props.leadAssign) === null || _d === void 0 ? void 0 : _d.parentLeadId) === "") &&
                                            !((props === null || props === void 0 ? void 0 : props.leadAssign.statusId.toString()) ===
                                                (leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.wonConvertedStatusIdForLead) ||
                                                (props === null || props === void 0 ? void 0 : props.leadAssign.statusId.toString()) ===
                                                    (leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.lostNotConveretdStatusIdForLead) ||
                                                (props === null || props === void 0 ? void 0 : props.leadAssign.statusId.toString()) ===
                                                    (leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.expiredNotConvertedStatusIdForLead)))
                                            props === null || props === void 0 ? void 0 : props.getShowEdit(props === null || props === void 0 ? void 0 : props.leadAssign, IEditLeadAccessPayloadEnum.SPLIT_FLAG);
                                    } }, "Split Lead")))),
                        ((_w = oldViewLeadData === null || oldViewLeadData === void 0 ? void 0 : oldViewLeadData.data) === null || _w === void 0 ? void 0 : _w.isSentMOM) === EAnswerType.YES && (React.createElement("div", { className: "view-mom-section d-flex flex-column align-items-center justify-content-between" },
                            React.createElement(Edelicon, { className: "edel-icon-view-mail", paths: 4 }),
                            React.createElement(EdButton, { btnTyp: "black_one", value: "View MOM", className: "text-decoration-underline", onClick: function () {
                                    var _a;
                                    props === null || props === void 0 ? void 0 : props.getMomViewDetails((_a = props === null || props === void 0 ? void 0 : props.leadAssign) === null || _a === void 0 ? void 0 : _a.leadId);
                                    props === null || props === void 0 ? void 0 : props.setViewMom(true);
                                    props === null || props === void 0 ? void 0 : props.setViewLead(false);
                                } })))))),
            React.createElement("div", { className: "accordion-section" },
                !((_x = oldViewLeadData === null || oldViewLeadData === void 0 ? void 0 : oldViewLeadData.data) === null || _x === void 0 ? void 0 : _x.isParent) ? (React.createElement(Accordion, { flush: true, defaultActiveKey: "Lead Details" },
                    React.createElement(Accordion.Item, { eventKey: "Lead Details" },
                        React.createElement(Accordion.Header, { className: " DMSanN_16_400 txt_black-seven" }, "Lead Details"),
                        React.createElement(Accordion.Body, { className: "all-property-container" },
                            React.createElement("div", { className: "properties-except-comment" },
                                React.createElement("div", { className: "single-property-container" },
                                    React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey" }, "Partner Lead Id"),
                                    React.createElement("div", { className: "ellipsis p-0" },
                                        React.createElement("span", { className: "DMSanM_14_500 txt_black-seven" }, ((_y = oldViewLeadData === null || oldViewLeadData === void 0 ? void 0 : oldViewLeadData.data) === null || _y === void 0 ? void 0 : _y.parentLeadId)
                                            ? oldViewLeadData.data.parentLeadId
                                            : "-"))),
                                React.createElement("div", { className: "single-property-container" },
                                    React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey" }, "Partner Name"),
                                    React.createElement("div", { className: "ellipsis p-0", title: (_z = oldViewLeadData === null || oldViewLeadData === void 0 ? void 0 : oldViewLeadData.data) === null || _z === void 0 ? void 0 : _z.partnerName },
                                        React.createElement("span", { className: "DMSanM_14_500 txt_black-seven" }, ((_0 = oldViewLeadData === null || oldViewLeadData === void 0 ? void 0 : oldViewLeadData.data) === null || _0 === void 0 ? void 0 : _0.partnerName)
                                            ? oldViewLeadData.data.partnerName
                                            : "-"))),
                                ChildLeadData &&
                                    (ChildLeadData === null || ChildLeadData === void 0 ? void 0 : ChildLeadData.length) > 0 &&
                                    (ChildLeadData === null || ChildLeadData === void 0 ? void 0 : ChildLeadData.map(function (lead, j) { return (React.createElement("div", { className: "single-property-container" },
                                        React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey" }, "Client Lead Id " + (j + 1)),
                                        React.createElement("div", { className: "ellipsis p-0" },
                                            React.createElement("span", { className: "DMSanM_14_500 txt_black-seven" }, lead === null || lead === void 0 ? void 0 : lead.leadId)))); }))))))) : (React.createElement(React.Fragment, null,
                    React.createElement(Accordion, { flush: true, defaultActiveKey: "Lead Details" },
                        React.createElement(Accordion.Item, { eventKey: "Lead Details" },
                            React.createElement(Accordion.Header, { className: " DMSanN_16_400 txt_black-seven" }, "Lead Details"),
                            React.createElement(Accordion.Body, { className: "all-property-container" },
                                React.createElement("div", { className: "properties-except-comment" }, ChildLeadData &&
                                    (ChildLeadData === null || ChildLeadData === void 0 ? void 0 : ChildLeadData.length) > 0 &&
                                    (ChildLeadData === null || ChildLeadData === void 0 ? void 0 : ChildLeadData.map(function (lead, j) { return (React.createElement("div", { className: "single-property-container" },
                                        React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey" }, "Client Lead Id " + (j + 1)),
                                        React.createElement("div", { className: "ellipsis p-0" },
                                            React.createElement("span", { className: "DMSanM_14_500 txt_black-seven" }, lead === null || lead === void 0 ? void 0 : lead.leadId)))); })))))))),
                newViewLeadDataFormat.map(function (section, i) {
                    return (React.createElement(Accordion, { flush: true, defaultActiveKey: section.title, className: section.title === "Task Descripton" &&
                            "task-description-class" },
                        React.createElement(Accordion.Item, { eventKey: section.title },
                            React.createElement(Accordion.Header, { className: " DMSanN_16_400 txt_black-seven" }, section.title),
                            React.createElement(Accordion.Body, { className: "all-property-container" },
                                React.createElement("div", { className: "properties-except-comment" }, section.details.map(function (property, j) {
                                    var _a;
                                    return (React.createElement("div", { className: "single-property-container" },
                                        React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey" }, property.subtitle),
                                        React.createElement("div", { className: "".concat(property.subtitle === "" ? "" : "ellipsis", " p-0"), title: typeof property.value === "string" &&
                                                property.value !== "-"
                                                ? property.value
                                                : "" },
                                            React.createElement("span", { className: "DMSanM_14_500 txt_black-seven", onClick: function (e) {
                                                    hanleonClickForOrderIdRedirection(property);
                                                    if ((property === null || property === void 0 ? void 0 : property.subtitle) === "Order Id" &&
                                                        isShowRedirectionPopup) {
                                                        props === null || props === void 0 ? void 0 : props.setViewLead(false);
                                                        props === null || props === void 0 ? void 0 : props.setOrderIdPopUpInfo(function (prev) { return (__assign(__assign({}, prev), { isShow: true })); });
                                                    }
                                                } }, (_a = property === null || property === void 0 ? void 0 : property.value) !== null && _a !== void 0 ? _a : "-"))));
                                }))))));
                }),
                React.createElement(Accordion, { flush: true, defaultActiveKey: "Comments" },
                    React.createElement(Accordion.Item, { eventKey: "Comments" },
                        React.createElement(Accordion.Header, { className: " DMSanN_16_400 txt_black-seven" }, "Comments"),
                        React.createElement(Accordion.Body, { className: "all-comments-container " },
                            React.createElement("div", { className: "comments-container", ref: myRef }, ((_1 = internalComments === null || internalComments === void 0 ? void 0 : internalComments.internalComments) === null || _1 === void 0 ? void 0 : _1.length) == 0 ? (loader ? (React.createElement(React.Fragment, null,
                                React.createElement(Row, { className: "w-100 " },
                                    React.createElement(Spinner, { animation: "border", variant: "primary" })))) : (React.createElement(ErrorNotification, { displayType: ErrorDisplayType.INSECTION, errMsg: "No Data Found", isOpen: true }))) : (React.createElement(React.Fragment, null, internalComments.internalComments.map(function (singleCommentDetail) {
                                return (React.createElement("div", { className: "single-comment-container" },
                                    React.createElement("div", { className: "profile-pic" },
                                        React.createElement("span", null, singleCommentDetail.name
                                            .charAt(0)
                                            .toUpperCase())),
                                    React.createElement("div", { className: "comment-details" },
                                        React.createElement("div", { className: "date-and-name" },
                                            React.createElement("span", { className: "name DMSanN_14_400 txt-midnight-blue" }, singleCommentDetail.name),
                                            React.createElement("span", { className: "date DMSansMedium_12_500 txt_secondary-gray" }, singleCommentDetail.commentDate)),
                                        React.createElement("div", { className: "message DMSanN_16_400 txt_black-seven" }, singleCommentDetail.comment))));
                            })))),
                            React.createElement("div", { className: "input-and-sendicon" },
                                React.createElement("input", { type: "text", className: "message-input-field", placeholder: "Response", defaultValue: comment, value: comment, onChange: function (e) {
                                        setComment(e.target.value);
                                    }, onKeyDown: function (e) {
                                        if (e.key === "Enter" &&
                                            comment &&
                                            comment.length > 0) {
                                            updateInternalComment(comment);
                                        }
                                    } }),
                                React.createElement("span", { className: "send-icon" },
                                    React.createElement("i", { className: "edel-icon-send-message hand_cursor", onClick: function () {
                                            if (comment && comment.length > 0) {
                                                updateInternalComment(comment);
                                            }
                                        } }))))))))) : (React.createElement(React.Fragment, null,
            React.createElement(Loader, null))),
        redirectionError && (React.createElement(GenericToast, { containerPosition: "fixed", backGroundColor: "Dark", position: "middle-center", delay: 3000, close: true, title: "Warning", message: "Redirection link not generated for this order id", autohide: true, setClose: function () {
                setRedirectionError(false);
            } }))));
};
export default ViewLeadNew;
